interface ReverseGeocodeResult {
  address: string;
  city: string;
  streetName?: string;
  streetStart?: string;
}

export const reverseGeocode = async (
  lat: number,
  lng: number,
): Promise<ReverseGeocodeResult> => {
  try {
    const url = `https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/reverseGeocode?f=json&location=${lng},${lat}&outFields=*`;

    const response = await fetch(url);
    const data = await response.json();

    const arcgisAddress = data?.address || {};
    const formattedAddress =
      arcgisAddress.Address || arcgisAddress.Match_addr || "Unknown Location";
    const numberMatch = formattedAddress.match(/^\s*(\d+[\w-]*)\s+(.*)$/);

    console.log("arc gis addr", data);

    return {
      address: formattedAddress,
      city: arcgisAddress.City || "",
      streetName:
        arcgisAddress.StName || numberMatch?.[2]?.trim() || undefined,
      streetStart: arcgisAddress.AddNum || numberMatch?.[1] || undefined,
    };
  } catch (error) {
    console.error("Reverse geocode error:", error);

    return {
      address: "Unable to fetch address",
      city: "",
    };
  }
};
